module.exports = __webpack_public_path__ + "img/on-boarding-tools.b976d3a0.png";